module.exports = __webpack_public_path__ + "static/media/default-image.e08eb423.png";